import { render } from "./cpt-three-server-room-option.vue?vue&type=template&id=e71af356"
import script from "./cpt-three-server-room-option.vue?vue&type=script&lang=js"
export * from "./cpt-three-server-room-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__